import React from "react";

const TermsAndConditions = () => {
  return (
    <>
      <meta content="text/html; charset=UTF-8" httpEquiv="content-type" />
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            '@import url(https://themes.googleusercontent.com/fonts/css?kit=fpjTOVmNbO4Lz34iLyptLUXza5VhXqVC6o75Eld_V98);ol{margin:0;padding:0}table td,table th{padding:0}.c8{padding-top:0pt;padding-bottom:0pt;line-height:1.0;orphans:2;widows:2;text-align:left;height:12pt}.c1{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Calibri";font-style:normal}.c7{padding-top:30pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c6{padding-top:15pt;padding-bottom:7.5pt;line-height:1.0;orphans:2;widows:2;text-align:left}.c5{color:#000000;text-decoration:none;vertical-align:baseline;font-size:18pt;font-style:italic}.c4{color:#000000;text-decoration:none;vertical-align:baseline;font-size:12pt;font-style:normal}.c2{background-color:#ffffff;max-width:451.3pt;padding:72pt 72pt 72pt 72pt}.c0{font-weight:400;font-family:"Arial"}.c3{font-weight:700;font-family:"Arial"}.title{padding-top:24pt;color:#000000;font-weight:700;font-size:36pt;padding-bottom:6pt;font-family:"Calibri";line-height:1.0;page-break-after:avoid;orphans:2;widows:2;text-align:left}.subtitle{padding-top:18pt;color:#666666;font-size:24pt;padding-bottom:4pt;font-family:"Georgia";line-height:1.0;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}li{color:#000000;font-size:12pt;font-family:"Calibri"}p{margin:0;color:#000000;font-size:12pt;font-family:"Calibri"}h1{padding-top:24pt;color:#000000;font-weight:700;font-size:24pt;padding-bottom:6pt;font-family:"Calibri";line-height:1.0;page-break-after:avoid;orphans:2;widows:2;text-align:left}h2{padding-top:0pt;color:#000000;font-weight:700;font-size:18pt;padding-bottom:0pt;font-family:"Times New Roman";line-height:1.0;orphans:2;widows:2;text-align:left}h3{padding-top:14pt;color:#000000;font-weight:700;font-size:14pt;padding-bottom:4pt;font-family:"Calibri";line-height:1.0;page-break-after:avoid;orphans:2;widows:2;text-align:left}h4{padding-top:12pt;color:#000000;font-weight:700;font-size:12pt;padding-bottom:2pt;font-family:"Calibri";line-height:1.0;page-break-after:avoid;orphans:2;widows:2;text-align:left}h5{padding-top:11pt;color:#000000;font-weight:700;font-size:11pt;padding-bottom:2pt;font-family:"Calibri";line-height:1.0;page-break-after:avoid;orphans:2;widows:2;text-align:left}h6{padding-top:10pt;color:#000000;font-weight:700;font-size:10pt;padding-bottom:2pt;font-family:"Calibri";line-height:1.0;page-break-after:avoid;orphans:2;widows:2;text-align:left}'
        }}
      />
      <p className="c6">
    <span className="c3 c5">
      Allgemeine Geschäftsbedingungen der Arbopark Promotion AG
    </span>
      </p>
      <p className="c7">
        <span className="c3">1. Geltungsbereich</span>
        <span className="c0">
      <br />
      Diese Allgemeinen Geschäftsbedingungen („AGB“) der Arbopark Promotion AG,
      Stegackerstrasse 6, 8409 Winterthur (nachfolgend „Arbopark Promotion
      AG“),gelten für sämtliche Geschäftsbeziehungen der Arbopark Promotion AG
      mit ihren Kunden. Die Arbopark Promotion AG bietet Dienstleistungen an im
      Bereich Freizeitanlagen. Zudem besitzt und betreibt sie dafür die Website
      www.arbopark.ch und darin einen Webshop. Als Kunde wird jede natürliche
      und juristische Person bezeichnet, welche mit der Arbopark Promotion AG
      geschäftliche Beziehungen pflegt. Diese AGB gelten ausschliesslich.
      Entgegenstehende, ergänzende oder von diesen AGB abweichende Bedingungen
      bedürfen zu ihrer Geltung der ausdrücklichen schriftlichen Bestätigung
      durch die Arbopark Promotion AG. Der Kunde bestätigt bei der
      Inanspruchnahme von Dienstleistungen der Arbopark Promotion AG, und bei
      der Nutzung von www.arbopark.ch bzw. bei Vertragsschluss diese AGB
      umfassend anzuerkennen.
      <br />
      <br />
    </span>
        <span className="c3">
      2. Informationen auf www.arbopark.ch und am Anschlag bei der
      Freizeitanlage
    </span>
        <span className="c0">
      <br />
      www.arbopark.ch beinhaltet Informationen über Dienstleistungen.
      Preisänderungen sowie sonstige Änderungen bleiben vorbehalten. Alle
      Angaben auf www.arbopark.ch (Dienstleistungsbeschreibungen, Abbildungen,
      Filme und sonstige Angaben) sind nur als Näherungswerte zu verstehen und
      stellen insbesondere keine Zusicherung von Eigenschaften oder Garantien
      dar, ausser es ist explizit anders vermerkt. Die Arbopark Promotion AG
      bemüht sich, sämtliche Angaben und Informationen auf www.arbopark.ch
      korrekt, vollständig, aktuell und übersichtlich bereitzustellen, jedoch
      kann die Arbopark Promotion AG wederausdrücklich noch stillschweigend
      dafür gewährleisten. Sämtliche Angebote auf www.arbopark.ch und
      angeschlagen bei der Freizeitanlage gelten als freibleibend und sind nicht
      als verbindliche Offerte zu verstehen. Die Arbopark Promotion AG kann
      keine Garantieabgeben, dass die auf www.arbopark.ch aufgeführten und bei
      der Freizeitanlage angeschlagenen Dienstleistungen erbracht werden können.
      Daher sind alle Angaben zu Dienstleistungen ohne Gewähr und können sich
      jederzeit und ohne Ankündigung ändern.
      <br />
      <br />
    </span>
        <span className="c3">3. Vertragsabschluss</span>
        <span className="c0">
      ‍<br />
      Der Vertragsabschluss kommt durch Kauf von Tickets und Dienstleistungen an
      der Kasse der Freizeitanlage oder über den Webshop zustande. Unternehmen
      können die Freizeitanlage im Voraus reservieren und die Kostenmittels
      Rechnung bezahlen, wobei die Arbopark Promotion AG ohne Angabe von Gründen
      Vorauskasse verlangen kann. Diesfalls kommt der Vertrag zustande, sobald
      die Arbopark Promotion AG die Reservation schriftlich bestätigt. Von der
      Arbopark Promotion AG gemachte Angebotesind freibleibend und, sofern
      nichts anders vermerkt ist, 14 Tage gültig. Sieverstehen sich stets
      vorbehältlich Verfügbarkeit der Anlage zum Zeitpunkt der schriftlichen
      Reservationsbestätigung durch die Arbopark Promotion AG. Die Tickets für
      die Freizeitanlage sind nicht personalisiert und übertragbar. Kinder und
      Jugendlicheunter 18 Jahren können die Dienstleistungen der Arbopark
      Promotion AG nur mit schriftlicher Einwilligung eines
      Erziehungsberechtigten in Anspruch nehmen.
      <br />
      <br />
    </span>
        <span className="c3">4. Preise</span>
        <span className="c0">
      <br />
      Vorbehaltlich anderweitiger Offerten verstehen sich alle Preise in
      Schweizer Franken (CHF), inklusive Mehrwertsteuer (MWST).Die Arbopark
      Promotion AG behält sich vor, die Preise jederzeit zu ändern. Es gelten
      die zum Zeitpunkt des Vertragsabschlusses vereinbarten Preise. Gutscheine
      der Arbopark Promotion AG haben eine Gültigkeit von 5 Jahren. Verfallende
      Gutscheine werden nicht erstattet.
      <br />
      <br />
    </span>
        <span className="c3">5. Bezahlung</span>
        <span className="c0">
      <br />
      Unternehmen, welchen die Arbopark Promotion AG Rechnung stellt, sind
      verpflichtet, die geschuldeten Beträge innert 30 Tagen ab Rechnungsdatum
      zu bezahlen. Wird die Rechnung nicht binnen vorgenannter Zahlungsfrist
      beglichen, wird der Kunde abgemahnt. Begleicht der Kunde die Rechnung
      nicht binnen der angesetzten Mahnfrist fällt er automatisch in Verzug und
      schuldet eine Mahngebühr von CHF 20.00. Ab Zeitpunkt des Verzugs schuldet
      der Kunde zudem Verzugszinsen in der Höhe der gesetzlichen 5 %.
      <br />
      <br />
    </span>
        <span className="c3">6. Pflichten der Arbopark Promotion AG</span>
        <span className="c0">
      <br />
      Die Arbopark Promotion AG verpflichtet sich, die vereinbarten
      Dienstleistungen gewissenhaft zu erbringen und die Freizeitanlage
      samtnotwendiger Gerätschaft in guten Zustand zu erhalten und für die zur
      vorgesehenen Zeit vereinbarten Nutzung zur Verfügung zu stellen.
      Weiterverpflichtet sich die Arbopark Promotion AG, die Benutzer der
      Freizeitanlage vor der Benutzung der Bahn zu instruieren und einzuweisen.
      Im Übrigen erfüllt die Arbopark Promotion AG ihre Verpflichtung durch
      Erbringung der vereinbarten Dienstleistungen. Für alle Dienstleistungen
      der Arbopark Promotion AG gilt als Erfüllungsort deren Sitz, es sei denn,
      es werden anderweitige Vereinbarungen getroffen. Die Arbopark Promotion AG
      hat das ausdrückliche Recht, zur Erledigung ihrer vertragsgemässen
      Pflichten Hilfspersonen beizuziehen. Sie hat sicherzustellen, dass der
      Beizug der Hilfsperson unter Einhaltung aller zwingenden gesetzlichen
      Bestimmungen und allfälliger Gesamtarbeitsverträge erfolgt.
      <br />
      <br />
    </span>
        <span className="c3">7. Pflichten des Kunden</span>
        <span className="c0">
      <br />
      Der Kunde ist angehalten, sich zum vereinbarten Zeitpunkt bei der
      Freizeitanlage einzufinden und den Anweisungen und Instruktionen des
      Personals der Arbopark Promotion AG vollumfänglich Folge zu leisten. Nimmt
      der Kunde die Dienstleistungen der Arbopark Promotion AG nicht zum
      vereinbarten Zeitpunkt in Anspruch, verfallen die gekauften Tickets und
      der bestellte Anspruch auf Konsumation ohne Rückerstattung des bezahlten
      Preises und hat der Kunde kein Recht auf verspätete Inanspruchnahme der
      Dienstleistungen. Die Arbopark Promotion AG bemüht sich jedoch, dem Kunden
      nach Möglichkeit einen Ersatztermin zur in Inanspruchnahme der
      Dienstleistungen anzubieten.
      <br />
      <br />
      Änderungen des gebuchten Events (Anzahl Personen, Menü, Programm, etc.)
      müssen spätestens 48 Stunden vor Eventbeginn der Arbopark Promotion AG
      mitgeteilt werden. Bei verspätet mitgeteilten Änderungen kann die Arbopark
      Promotion AG die Verfügbarkeit und Möglichkeit von zusätzlich gewünschten
      Leistungen nicht garantieren. Sollte der Kunde die Fahrregeln oder
      sonstige Anweisungen des Personals keine Folge leisten, ist das Personal
      der Arbopark Promotion AG berechtigt, den Kunden jederzeit von der Bahn zu
      weisen, ohne dass dieser zur Rückerstattung des Ticketpreises berechtigt
      wäre.
      <br />
      <br />
    </span>
        <span className="c3">8. Fahr- und Verhaltensregeln</span>
        <span className="c0">
      <br />
      Der Kunde verpflichtet sich, die nachfolgendaufgeführten Fahr- und
      Verhaltensregeln uneingeschränkt einzuhalten:
      <br />
      8.1. Der Kunde leistet den Anweisungen und Instruktionen des Personals der
      Arbopark Promotion AG vollumfänglich und umgehend Folge.
      <br />
      8.2. Beim Betreten der Kartbahn ist das Tragen eines Helmes Pflicht.
      <br />
      8.3. Bei Leihhelmen ist aus hygienischen Gründen das Tragen einer
      KopfhaubePflicht.
      <br />
      8.4. Beim Benutzen der Kartbahn ist festes Schuhwerk Pflicht. Flip-Flops,
      High-Heels und Sandalen sind verboten.
      <br />
      8.5. Es ist auf enganliegende Kleidung zu achten. Schals, Tücher und
      anderelosen Kleidungsstücke sind verboten.
      <br />
      8.6. Grobfahrlässiges und rücksichtsloses Fahren ist verboten und führt
      zurWegweisung von der Kartbahn.
      <br />
      8.7. Fahren unter Alkoholeinfluss oder sonstigen berauschenden Mitteln
      iststreng verboten.
      <br />
      8.8. Start, Ende und Abbruch des Rennens wird mit Signalanlagen angezeigt.
      DieSignalanzeigen sind zu befolgen.
      <br />
      8.9. Die Mindestkörpergrösse für die Benutzung der Kartbahn beträgt
      ausSicherheitsgründen 1,30 Meter.
      <br />
      8.10. Auf dem Gelände und in den Räumlichkeiten der Kartbahn dürfen, wenn
      nicht anders vereinbart, keine mitgebrachten Esswaren und Getränke
      konsumiert werden.
      <br />
      <br />
    </span>
        <span className="c3">9. Rücktritt</span>
        <span className="c0">
      <br />
      Die Arbopark Promotion AG hat das Recht, jederzeit ohne Angabe von Gründen
      vom Vertrag zurückzutreten und ihre Dienstleistungen zu verweigern. Tritt
      die Arbopark Promotion AG vom Vertrag zurück oder verweigert ihre
      vereinbarten Dienstleistungen, werden dem Kunden die bereits bezahlten
      Kosten ohne Zinsenzurückerstattet. Bei Dienstleistungen in den Monaten
      Januar bis August hat der Kunde das Recht, ohne Angabe von Gründen bis 48
      Stunden vor Inanspruchnahme der Dienstleistungen ohne Kostenfolge vom
      Vertrag zurückzutreten. Bei Dienstleistungen in den Monaten September bis
      Dezember hat der Kunde das Recht, bis 7 Tage vor Inanspruchnahme der
      Dienstleistungen ohne Kostenfolge vom Vertrag zurückzutreten. Tritt der
      Kunde innert zulässiger Frist vom Vertrag zurück, werden ihm bereits
      geleistete Zahlungen vollumfänglich zurückerstattet. Tritt der Kunde
      verspätet zurück, hat er 50 % des vereinbarten Preises zu bezahlen. Für
      die Einhaltung dieser Fristen ist der Tag des Zugangs der Erklärung des
      Kunden bei der Arbopark Promotion AG massgebend.
      <br />
      <br />
    </span>
        <span className="c3">9.1. Online Tickets</span>
        <span className="c0">
      <br />
      Mit den Kauf von Einzelfahrten über den Webshop von der Arbopark Promotion
      AG kann der Kunde für sich selbst Termine für Fahrtenreservieren. Sollte
      der Kunde nicht pünktlich zur reservierten Startzeiterscheinen, Verfällt
      das Ticket und der Anspruch auf Rückerstattung des Kaufpreises.
      <br />
      <br />
    </span>
        <span className="c3">10. Haftung und Freistellung</span>
        <span className="c0">
      <br />
      Der Kunde betritt und benutzt das Gelände und die Anlagen der Arbopark
      Promotion AG auf eigenes Risiko. Eltern haften für Ihre Kinder. Die
      Arbopark Promotion AG schliesst jede Haftung, unabhängig von ihrem
      Rechtsgrund, sowie Schadenersatzansprüche gegen die Arbopark Promotion AG
      und allfällige Hilfspersonen und Erfüllungsgehilfen, aus. Die Arbopark
      Promotion AG haftet insbesondere nicht für indirekte Schäden und
      Mangelfolgeschäden, entgangenen Gewinn oder sonstige Personen-,Sach- und
      reine Vermögensschäden des Kunden. Vorbehalten bleibt eine weitergehende
      zwingende gesetzliche Haftung, beispielsweise für grobe Fahrlässigkeit
      oder rechtswidrige Absicht. Der Kunde ist für seinen ausreichenden
      Versicherungsschutz für sich selbst, und gegenüber Drittenverantwortlich.
      Der Kunde respektive die Erziehungsberechtigten stellen die
      <br />
      Arbopark Promotion AG von Haftungsansprüchen anderer Nutzer, Besucher und
      Dritten für Schäden frei, welche sie in Zusammenhang mit dem Betreten und
      Benutzen der Anlagen der Arbopark Promotion AG zu vertreten haben.
      <br />
      <br />
    </span>
        <span className="c3">11. Datenschutz</span>
        <span className="c0">
      <br />
      Die Datenschutzbestimmungen der Arbopark Promotion AG für die Website
      www.arbopark.ch sind integraler Bestandteil dieser AGB.
      <br />
      <br />
    </span>
        <span className="c3">12. Änderungen</span>
        <span className="c0">
      <br />
      Diese Allgemeinen Geschäftsbedingungen können von der Arbopark Promotion
      AG jederzeit geändert werden. Die neue Version tritt durch Publikation auf
      der Website der Arbopark Promotion AG in Kraft. Für die Kunden gilt
      grundsätzlich die Version der AGB, welche zum Zeitpunkt des
      Vertragsabschlusses in Kraft ist. Es sei denn, der Kunde habe einer
      neueren Version der AGB zugestimmt.
      <br />
      <br />
    </span>
        <span className="c3">13. Höhere Gewalt</span>
        <span className="c0">
      <br />
      Wird die Erfüllung durch die Arbopark Promotion AG oder beigezogenen
      Dritten infolge höherer Gewalt oder aufgrund von Umständen, welche die
      Arbopark Promotion AG nicht zu verantworten hat unmöglich, so ist die
      Arbopark Promotion AG während der Dauer der höheren Gewalt oder dieser
      Umstände sowie einer angemessenen Anlaufzeitnach deren Ende von der
      Erfüllung der betroffenen Pflichten befreit. Dauert die höhere Gewalt oder
      diese Umstände länger als 30 Tage, kann die Arbopark Promotion AG vom
      Vertrag zurücktreten.
      <br />
      Die Arbopark Promotion AG hat dem Kunden bereits geleistetes Entgelt für
      noch nicht geleistete Dienstleistungen vollumfänglich zurückzuerstatten.
      Jegliche weiteren Ansprüche, insbesondere Schadenersatzansprüche infolge
      höherer Gewalt, oder aufgrund von Umständen, welche die Arbopark Promotion
      AG nicht zu verantworten hat, sind ausgeschlossen.
      <br />
      <br />
    </span>
        <span className="c3">14. Weitere Bestimmungen</span>
        <span className="c0">
      <br />
      Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise nichtig
      und/oder unwirksam sein, bleibt die Gültigkeit und/oder Wirksamkeit der
      übrigen Bestimmungen oder Teile solcher Bestimmungen unberührt .Die
      ungültigen und/oder unwirksamen Bestimmungen werden durch solche ersetzt,
      die dem Sinn und Zweck der ungültigen und/oder unwirksamen Bestimmungen in
      Rechtwirksamer Weise wirtschaftlich am nächsten kommt. Das gleiche gilt
      bei eventuellen Lücken der Regelung. Im Falle von Streitigkeiten kommt
      ausschliesslich materielles Schweizer Recht unter Ausschluss von
      kollisionsrechtlichen Normen zur Anwendung. Der Gerichtsstand ist
      Winterthur, soweit das Gesetz keine zwingenden Gerichtsstände vorsieht.
    </span>
      </p>
      <p className="c8">
        <span className="c1" />
      </p>
    </>

  );
};

export default TermsAndConditions;